import React, { useEffect } from 'react';
import EmailField from '@ff/ui/Form2/presets/EmailField';
import FirstNameField from '@ff/ui/Form2/presets/FirstNameField';
import LastNameField from '@ff/ui/Form2/presets/LastNameField';
import PhoneNumberField from '@ff/ui/Form2/presets/PhoneNumberField';
import ZipCodeField from '@ff/ui/Form2/presets/ZipCodeField';
import useUser from 'client/hooks/queries/useUser';
import { useFormContext } from '@ff/ui/Form2/Context';

export default function InfoForm() {
  const form = useFormContext();

  const { user } = useUser();

  useEffect(() => {
    if (user) {
      form.setValues({
        ...form.values,
        email: user.email || '',
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        phoneNumber: user.mobile || '',
        zipCode: user.addressCode || ''
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]); // only check user

  return (
    <>
      <EmailField required disabled />
      <FirstNameField required />
      <LastNameField required />
      <PhoneNumberField required />
      <ZipCodeField required />
    </>
  )
}

